import React, { useMemo } from "react";
import Card from "@unum/card";
import styles from "./Hero.module.scss";
import { CampaignProps } from "./types";
import classnames from "classnames";

const Campaign = ({ title, asset, align, ctas, children }: CampaignProps) => {
  const assetNode = useMemo(() => {
    if (!React.isValidElement<{ className: string }>(asset)) {
      return asset;
    }
    return React.cloneElement(asset, {
      className: classnames(
        asset.props.className,
        styles["image"],
        "hero__image"
      )
    });
  }, [asset]);

  return (
    <div className={classnames(styles["Hero"], styles["Hero--campaign"])}>
      <div className={classnames(styles["hero-wrapper"])}>
        <div className={classnames("spring", styles["content-wrapper"])}>
          <div
            className={classnames(
              "col-xs-12 col-md-6 col-lg-5",
              styles["card-wrapper"],
              {
                [styles["card-wrapper--right"]]: align === "right"
              }
            )}
          >
            <Card className={styles["card"]}>
              <Card.Header level={3} className={styles["header"]}>
                {title}
              </Card.Header>
              <Card.Body className={styles["body"]}>{children}</Card.Body>
              <Card.Footer className={styles["footer"]}>{ctas}</Card.Footer>
            </Card>
          </div>
        </div>
        <div className={styles["image-wrapper"]}>{assetNode}</div>
      </div>
    </div>
  );
};

export default Campaign;
